import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconAiSparkle = ({ width = 21, height = 21, ...props }: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.3546 4.86719L15.9515 7.78531C16.1134 8.07844 16.354 8.31906 16.6471 8.48094L19.5652 10.0778C20.2215 10.4366 20.2215 11.3772 19.5652 11.7316L16.6471 13.3284C16.354 13.4903 16.1134 13.7309 15.9515 14.0241L14.3546 16.9422C13.9959 17.5984 13.0552 17.5984 12.7009 16.9422L11.104 14.0241C10.9421 13.7309 10.7015 13.4903 10.4084 13.3284L7.49023 11.7316C6.83398 11.3728 6.83398 10.4322 7.49023 10.0778L10.4084 8.48094C10.7015 8.31906 10.9421 8.07844 11.104 7.78531L12.7009 4.86719C13.0596 4.21094 14.0002 4.21094 14.3546 4.86719Z'
        fill='#00AFFF'
      />
      <path
        opacity={0.35}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.9675 2.2225L6.54063 3.5525C6.61937 3.73625 6.76375 3.88063 6.9475 3.95938L8.2775 4.5325C8.9075 4.80375 8.9075 5.69625 8.2775 5.9675L6.9475 6.54063C6.76375 6.61937 6.61937 6.76375 6.54063 6.9475L5.9675 8.2775C5.69625 8.9075 4.80375 8.9075 4.5325 8.2775L3.95938 6.9475C3.88063 6.76375 3.73625 6.61937 3.5525 6.54063L2.2225 5.9675C1.5925 5.69625 1.5925 4.80375 2.2225 4.5325L3.5525 3.95938C3.73625 3.88063 3.88063 3.73625 3.95938 3.5525L4.5325 2.2225C4.80375 1.5925 5.69625 1.5925 5.9675 2.2225Z'
        fill='#00AFFF'
      />
      <path
        opacity={0.35}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.03812 13.4794L4.46688 14.4769C4.52813 14.6125 4.6375 14.7219 4.77312 14.7831L5.77062 15.2119C6.24312 15.4175 6.24312 16.0869 5.77062 16.2881L4.77312 16.7169C4.6375 16.7781 4.52813 16.8875 4.46688 17.0231L4.03812 18.0206C3.8325 18.4931 3.16313 18.4931 2.96187 18.0206L2.53312 17.0231C2.47187 16.8875 2.3625 16.7781 2.22688 16.7169L1.22938 16.2881C0.756875 16.0825 0.756875 15.4131 1.22938 15.2119L2.22688 14.7831C2.3625 14.7219 2.47187 14.6125 2.53312 14.4769L2.96187 13.4794C3.1675 13.0069 3.8325 13.0069 4.03812 13.4794Z'
        fill='#00AFFF'
      />
    </svg>
  )
}

export default memo(IconAiSparkle)
